module.exports = __webpack_public_path__ + "static/img/006.f509511b.jpg";